import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent {
  constructor(private router: Router) {}

  goToTerms(): void {
    this.router.navigate(['/terms']);
  }
}
